
/**
 *      Data-driven UI that displays the record data.ui
 *
 *      @author Irina Patrikeeva <irina.i.patrikeeva@nasa.gov>
 *
 *      Created on 06/06/2017
 *      Modified on 10/7/2021 by Nhi Cmerek
 */


/**
 * Empty Backbone model
 */
var BackboneModel = Backbone.Model.extend();

/**
 * Backbone.Collection that contains empty Backbone models
 */
var BackboneCollection = Backbone.Collection.extend({
    model: BackboneModel
});

/**
 * Global state of the page
 */
var GlobalPageState;

/**
 * Call Query Manager Web endpoint to get the HTML of the record page to render.
 * @param alias {string} record alias.
 * @param type {string} record type (index).
 * @param id {string} record id.
 * @param viewtype {string} record view type (i.e. "cdm", "ui", etc.).
 * @param version {*} [optional] EDI record iteration.
 */
function getRecordUI( alias, type, id, viewtype, version ) {
    // Get record model from Data Model Registry
    if (type) {
        getJSONUIModel(type,
            function (data) {
                displayRecordSections(alias, type, id, version, viewtype, data);
            },
            function (error) {
                console.log("Error getting UI model for type " + type);
                console.log(error);
                displayRecordSections(alias, type, id, version, viewtype, null);
            });
    } else {
        displayRecordSections(alias, type, id, version, viewtype, null);
    }
    x = -1;
    lastName = "";
    if (id === "tree_viewers-content") {
        $("#graph-region .panel-heading h4").each(function () {
            x++
            console.log($(this).text())
            let curName = $(this).text().replace("Collapse panelExpand panel", "")
            console.log(curName)
            if($("#tree_viewers-sidebar-" + curName)) {
                console.log("already exists")
            } else {
                $('<a id="tree_viewers-sidebar-' + curName.replace(
                    / |\//g, "_") + '" class="w3-bar-item" href="#panel-' + x + '-header" title="' + curName.replace(
                    / |\//g, "_") + '"> ' + curName + '</a>').insertAfter(
                    "#tree_viewers-sidebar" + lastName.replace(
                    / |\//g, "_"))
                console.log($(this).attr("name"), lastName)
                lastName = "-" + curName
            }

        })
    }
    x = -1;
    lastName = "";
    console.log('id: ', id );
    console.log("type: ", type );
    if (id === "panels-content") {                 // this currently never executes as the id here has the form of a GUID
        $("#panels-region .panel-heading").each(function () {
            x++
            console.log($(this))
            let curName = $(this).attr("name")
            // if ($("#panels-sidebar-" + curName)) {
            //     console.log("already exists")
            // } else {
                $('<a id="panels-sidebar-' + curName.replace(
                    / |\/|\)|\(/g, "_") + '" class="w3-bar-item" href="#panel-' + x + '-header" title="' + curName.replace(
                    / |\/|\)|\(/g, "_") + '"> ' + curName + '</a>').insertAfter(
                    "#panels-sidebar" + lastName.replace(
                    / |\/|\)|\(/g, "_"))
                console.log($(this).attr("name"), lastName)
                lastName = "-" + curName
            // }
        })
    }
    // $(".menu-links a").css("padding", "0px 8px")                   // ===== testing removal as this is already set in the css
    $(".panel-body").css("background-color", "white")
    $("#panels-region .panel-wrapper .panel-default").css("background-color", "white")
}

/**
 * Display record viewer sections in the order specified in the data model.
 * @param alias {string} record alias.
 * @param type {string} record type (index).
 * @param id {string} record id.
 * @param version {*} [optional] EDI record iteration.
 * @param viewtype {string} record view type (i.e. "cdm", "ui", etc.).
 * @param model {object} Data model object from the Data Model Registry.
 */
function displayRecordSections( alias, type, id, version, viewtype, model ) {


    // Determine the order of the record sections based on the model "ui_order" property
    var ui_order;

    // Get the order of the record from the model if it exists

    var model_properties;
    if ( model ) {
        var properties_array = model.properties;
        if ( properties_array && properties_array.length > 0 ) {
            model_properties = properties_array[ 0 ];
            if ( model_properties ){
                ui_order = model_properties.ui_order;
            }
        }
    }

    // Default order of the sections
    var order_object = {
        "history": { "order": "100", "title": "History" },
        "header": { "order": "200", "title": "Title" },
        "summary": { "order": "300", "title": "Summary" },
        "tree_viewers": { "order": "400", "title": "Graphs" },
        "risk_matrix": { "order": "500", "title": "Risk Matrix" },
        "panels": { "order": "600", "title": "Metadata" },
        "charts": { "order": "650", "title": "Charts" },
        "links": { "order": "700", "title": "Links"},
        "tables": {"order": "800", "title": "Tables" }
    };

    // Update the order and title sections by using the "ui_order" section of the model

    if ( ui_order ) {
        for ( var key in ui_order ) {
            if ( ui_order.hasOwnProperty( key ) ) {
                if ( order_object[ key ] ) {
                    var updatedvalue = ui_order[ key ];
                    if ( updatedvalue ) {
                        var oldvalue = order_object[ key ];
                        if ( updatedvalue.order ) {
                            oldvalue.order = updatedvalue.order;
                        }
                        if ( updatedvalue.title ) {
                            oldvalue.title = updatedvalue.title;
                        }
                        if ( updatedvalue.is_hidden ) {
                            oldvalue.is_hidden = updatedvalue.is_hidden;
                        }
                    }
                }
            }
        }

    }

    // Convert the order object into an array
    var order_properties = [];
    for ( var key in order_object ) {
        if ( order_object.hasOwnProperty( key )  ) {

            var key_object = order_object[ key ];

            // Don't show section if its ui_order object has an attribute "is_hidden": "true"
            if ( ! ( key_object && key_object.is_hidden && key_object.is_hidden.toString() === "true" ) ) {
                // Save the name of the section (key) into the property of the object
                order_object[ key ].name = key;
                order_object[ key ].title = order_object[ key ].title || "";
                order_properties.push( order_object[ key ] );
            }
        }
    }

    // Sort the page sections based on the order field
    var ordered_properties = order_properties.sort( compareByOrder );

    // Determine which sections are visible and which ones aren't
    var tree_viewers;
    var table_viewers;
    var risk_matrix;
    var charts;
    if ( model_properties ) {
        // Check if tree_viewers data model exists
        tree_viewers = model_properties.tree_viewers;
        table_viewers = model_properties.table_viewers;
        risk_matrix = model_properties.risk_matrix;
        charts = model_properties.chart_viewers;
    }

    // Builds the initial tableSortString
    var tableSortString = "";
    for ( var n in model.properties[0].table_viewers ) {
        var tmp_SortString = model.properties[0].table_viewers[ n ].initial_tableSortString;
        if ( tmp_SortString !== undefined && tmp_SortString !== '' && tmp_SortString !== null && tmp_SortString !== 'undefined' ) {
            if ( tableSortString !== "" ) {
                tableSortString += '|';
            };
            tableSortString += tmp_SortString;
        };
    };
    console.log('tableSortString: ', tableSortString );

    // Sets global state value for tableSortString
    if ( tableSortString !== "" ) {
        App.globalState.tableSortString = tableSortString;
    };

    // Builds default page length and starting page
    var pages = '';
    for ( var n in model.properties[0].table_viewers ) {

        if ( pages !== '' ) {
            pages += '|';
        };

        if ( model.properties[0].table_viewers[ n ].initial_pages == undefined ) {
            pages += model.properties[0].table_viewers[ n ].name + ':1:10';
            continue;
        };

        var tmp_PagesString = model.properties[0].table_viewers[ n ].initial_pages;
        pages += model.properties[0].table_viewers[ n ].name
        if ( tmp_PagesString !== undefined && tmp_PagesString !== '' && tmp_PagesString !== null && tmp_PagesString !== 'undefined' ) {
            pages += tmp_PagesString;
        } else {
            pages += ':1:10';
        };
    };
    console.log('pages: ', pages );

    // Sets global state value for tableSortString
    if ( pages !== "" ) {
        App.globalState.tablePagesString = pages;
    };



    // Display record viewer sections
    var record_page = document.getElementById('record-page');
    if ( record_page ) {
        for ( var i = 0; i < ordered_properties.length; i++ ) {
            var page_section = ordered_properties[ i ];
            if ( page_section ) {

                var section_name = page_section.name;

                if ( section_name ) {

                    // Create parent wrapper element first before calling the Query Web
                    var parent_element = document.createElement("div");
                    parent_element.id = section_name + "-content";
                    parent_element.class = section_name + "-wrapper";
                    parent_element.order = page_section.order;
                    record_page.append( parent_element );

                    // Always show header, record history, metadata panels and links

                    if ( section_name === "header") {
                        // Get record header (title, source, buttons, etc.)
                        displayRecordHeader( alias, type, id, version, 1 );
                        displaySideBarLink( page_section.title, section_name, parent_element.id );

                        // Calls Johns explore function to initialize his header functions
                        try {
                            INSIGHT.explore.header_init();
                            console.log('INSIGHT.explore.header_init() ran successfully');
                        }
                        catch (error) {
                            console.log(error);
                        };
                    }

                    if ( section_name === "history" ) {
                        // Get history
                        displayRecordHistory( type, id, 1 );
                    }
                    if ( section_name === "panels" ) {
                        // Get panels
                        displayRecordPanels( alias, type, id, viewtype, version, 1 );
                        displaySideBarLink( page_section.title, section_name, parent_element.id );
                    }
                    if ( section_name === "links") {
                        // Get links
                        displayRecordLinks( alias, type, id, null, 1 );
                        displaySideBarLink( page_section.title, section_name, parent_element.id );

                    }

                    // Show summary if it exists
                    if ( section_name === "summary") {
                        // Get links
                        displayRecordSummary( alias, type, id, version, section_name, 1 );
                        // Show summary in the content menu
                        displaySideBarLink( page_section.title, section_name, parent_element.id );
                        $('#' + section_name + '-sidebar');

                    }

                    // Show optional sections, only if data model contains the object for it,
                    // Optional data-driven sections are graphs (tree_viewers), risk matrix and tables
                    if ( section_name === "tree_viewers" && tree_viewers ) {
                        // Get graph
                        displayRecordGraph( alias, type, id, null, parent_element.id, 1 );
                        displaySideBarLink( page_section.title, section_name, parent_element.id );
                    }
                    if ( section_name === "risk_matrix" && risk_matrix ) {
                        // Get risk matrix
                        displayRecordRiskMatrix( alias, type, id, 1 );
                        displaySideBarLink( page_section.title, section_name, parent_element.id );
                    }
                    if ( section_name === "tables" && table_viewers ) {
                        // Get tables
                        displayRecordTables( alias, type, id, pages, 1, '', tableSortString );
                        displaySideBarLink( page_section.title, section_name, parent_element.id );
                    }

                    if ( section_name === "charts" && charts ) {
                        // Get charts
                        displayRecordCharts( alias, type, id, 1 );
                        displaySideBarLink( page_section.title, section_name, parent_element.id );
                    }
                }
            }
        }
    }

}

/**
 * Display a link in the side bar menu.
 * @param title {string} Title of the section.
 * @param sectionname {string} Secondary section name.
 * @param anchorid {string} ID of the section to navigate to.
 */

function displaySideBarLink( title, sectionname, anchorid) {

    // console.log('displaySideBarLink called ==============================');        // ===== testing only
    // console.log('title: ', title);
    // console.log('sectionname: ', sectionname );
    // console.log('anchorid: ', anchorid);

    var _searchParams = new URLSearchParams(window.location.search);
    var sidebar_param = _searchParams.get("sidebar");

    if ( sidebar_param !== null ) {

        var sidebar_params = sidebar_param.split(":");

        if ( sidebar_params.length !== 0 ) {
            var record_sidebar = document.getElementById('record-sidebar');

            record_sidebar.children[0].style.display = "none"
            record_sidebar.children[1].style.display = "none"

            document.getElementById("page-layout").children[1].style["margin-left"] = "400px";
            // document.getElementById("record-sidebar").style["width"] = "400px";

            document.getElementById("record-sidebar").setAttribute('style', 'position: absolute !important');
            document.getElementById("record-sidebar").style["width"] = "400px";
            document.getElementById("record-sidebar").style["margin-top"] = "10px";
    
            if ( sidebar_params.length === 1 ) {
                var url = "/explore/sidebar/" + sidebar_params[0] + "/" + sidebar_params[0];
            } else {
                var url = "/explore/editsidebar/" + sidebar_params[0] + "/" + sidebar_params[0] + "/" + sidebar_params[1];
            }
        
            sharedStylesGlobals.utils.fetchHTML( url,
                {}, 
                "GET", 
                'text/html'
                )
            .then(function(html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, "text/html");        
                var element = doc.getElementById('sidebar_holder');

                if ( document.getElementById('sidebar_holder') ) {
                    console.log('sidebar_holder already in DOM');
                } else {
                    record_sidebar.appendChild(element);
                };
                // console.log('element: ', element );

                // initializes the sidebar menu functions from explore
                INSIGHT.explore.editsidebar_init();

                // adds activesection title to viewpage title (used for DSP review page)
                var ele = document.getElementById('sidebar_holder');
                var h_region = document.getElementById("header-region");
                var title = h_region.getElementsByClassName("title");
                if ( ele.getElementsByClassName("activesection").length >= 1 && title[0].getElementsByClassName("font-lead").length <= 1 ) {
                    var title_text = ele.getElementsByClassName("activesection")[0].firstElementChild.textContent;
                    var title_0 = title[0];
                    var p = document.createElement("p");
                    p.className = "font-lead";
                    p.id = "header_region_menu_title";
                    p.textContent = title_text;
                    title_0.prepend( p );
                };

            })
            .catch(function(err) {  
                console.log('Failed to fetch explore sidebar: ', err);  
            });
        }
    } else {

        let sidebar;

        if ($) {
            sidebar = $('#page-layout #record-sidebar .w3-container.menu-links');
        }
    
        if (sidebar) {
            // Create a link in the side bar navigation
            let sidebar_link = document.createElement("a");
    
    
            let section_title = title || sectionname;
            if (section_title) {
                sidebar_link.id = sectionname + "-sidebar";
                sidebar_link.className = "w3-bar-item";
                sidebar_link.href = '#' + anchorid;
    
                sidebar_link.title = section_title;
                sidebar_link.alt = section_title;
                sidebar_link.innerText = section_title;
    
    
                sidebar.append(sidebar_link);
            }
        }
    }
}

/**
 * Compare two objects by their order attribute
 * @param a {object} - data object
 * @param b {object} - data object
 * @returns {number}
 */
function compareByOrder( a, b ) {

    if ( a && b ) {
        if ( a.order < b.order ) {
            return -1;
        } else if ( a.order > b.order ) {
            return 1;
        }
    }
    return 0;
}


/**
 * Display record header region generated by Query Manager Web.
 * @param alias {string} record alias.
 * @param type {string} record type (index).
 * @param id {string} record id.
 * @param version {*} [optional] EDI record iteration.
 * @param tryNumber {number} The number of times this function has been called.
 */
function displayRecordHeader ( alias, type, id, version, tryNumber ) {

    if ( alias && type && id && App && App.globalState && App.globalState.queryWebBase ) {

        var url = App.globalState.queryWebBase + '/recordheader/' + alias + '/' + type + '/' + id + '/';

        if ( version ) {
            url += '?version=' + version;
        }
        if ( url ) {

            var regionid = 'header-content';
            var iconid = 'header-loading-icon';

            // Display loading image
            var imageurl = "/static/images/skeleton-record-header.png";
            loadSkeletonImage( regionid, iconid, imageurl );

            $.ajax({
                url: url,
                data: {},
                dataType: 'html'
            })
            .done( function ( data ) {
                // Display region data
                renderPageRegion( data, regionid );

                // Hide loading icon
                hideLoadingIcon( iconid );
            })
            .fail(function ( data, textStatus, errorThrown ) {
                console.log("Error: Query Manager Web failure");
                console.log(data);
                console.log(textStatus);
                console.log(errorThrown);
                hideLoadingIcon(iconid);
                if ( tryNumber <= 5 ) {
                    retry( displayRecordHeader( alias, type, id, version, tryNumber + 1 ), tryNumber + 1, 5 );
                }
            });
        }
    }
}

/**
 * Moves viewpage submit button from title to end of page
 * updates styling to match w3 buttongs used in DSP
 */
function move_recordHeader_btns() {

    console.log("move record header buttons");

    var tables_content = document.getElementById("tables-content");
    var doc = document.getElementById("links-dropdown");
    var title_btns = doc.getElementsByClassName("link-title");

    for ( var index = title_btns.length - 1; index >= 0; index-- ) {
        var ele = title_btns[ index ];

        if ( ele.parentElement.getAttribute("display_at") !== null ) {
            var display_at = ele.parentElement.getAttribute("display_at");

            ele.style.display = "unset";
            // ele.innerHTML = ele.innerHTML.split("</i>")[0] + " " + ele.innerHTML.split("</i>")[1] + "</i>";
            ele.innerHTML = " " + ele.innerHTML.split("</i>")[1];

            if ( display_at.includes("right") ) {
                ele.style["float"] = "right";
                ele.style["margin-right"] = "-30px";
            };
            if ( display_at.includes("left") ) {
                ele.style["float"] = "left";
                ele.style["margin-left"] = "30px";
            };

            ele.className = "w3-button w3-blue w3-round-large ";

            tables_content.appendChild( ele );
        };
    };
}

/**
 * Display record history region generated by Query Manager Web.
 * @param type {string} record type (index).
 * @param id {string} record id.
 * @param tryNumber {number} The number of times this function has been called.
 */
function displayRecordHistory( type, id, tryNumber ) {

    if ( type && id && App && App.globalState && App.globalState.queryWebBase ) {

        var url = App.globalState.queryWebBase + '/recordhistory/' + type + '/' + id + '/';

        if ( url ) {

            var regionid = 'history-content';
            var iconid = 'history-loading-icon';

            // Display loading image
            // var imageurl = "/static/images/skeleton-record-history.png";
            // loadSkeletonImage( regionid, iconid, imageurl );

            $.ajax({
                url: url,
                data: {},
                dataType: 'html'
            })
            .done(function ( data ) {
                // Display region data
                renderPageRegion( data, regionid );

                // Hide loading icon
                hideLoadingIcon( iconid );

            })
            .fail(function ( data, textStatus, errorThrown ) {
                console.log("Error: Query Manager Web failure");
                console.log(data);
                console.log(textStatus);
                console.log(errorThrown);
                // hideLoadingIcon(iconid);
                if ( tryNumber <= 5 ) {
                    retry( displayRecordHistory( type, id, tryNumber + 1 ), tryNumber + 1, 5 );
                }
            });
        }
    }
}

/**
 * Display record summary region generated by Query Manager Web.
 * @param alias {string} record alias.
 * @param type {string} record type (index).
 * @param id {string} record id.
 * @param version {*} [optional] EDI record iteration.
 * @param section_name {string} The name of the summary section in the content menu.
 * @param tryNumber {number} The number of times this function has been called.
 */
function displayRecordSummary( alias, type, id, version, section_name, tryNumber ) {

    if ( alias && type && id && App && App.globalState && App.globalState.queryWebBase ) {

        var url = App.globalState.queryWebBase + '/recordsummary/' + alias + '/' + type + '/' + id + '/';

        if ( version ) {
            url += '?version=' + version;
        }
        if ( url ) {

            var regionid = 'summary-content';
            var iconid = 'summary-loading-icon';

            // Display loading image
            var imageurl = "/static/images/skeleton-record-summary.png";
            // loadSkeletonImage( regionid, iconid, imageurl );

            $.ajax({
                url: url,
                data: {},
                dataType: 'html'
            })
            .done( function ( data ) {

                // Display region data
                renderPageRegion( data, regionid );

                // Hide loading icon
                // hideLoadingIcon( iconid );

                // Check if the summary exists
                if ($('#summary-region') && $('#summary-region').children() &&  $('#summary-region').children().length === 0 && $('#' + section_name + '-sidebar')) {
                    $('#' + section_name + '-sidebar').hide();
                } else if ( $('#summary-region') && $('#summary-region').children() && $('#summary-region').children().length > 0 && $('#' + section_name + '-sidebar')) {
                    $('#' + section_name + '-sidebar').show();
                }
            })
            .fail(function ( data, textStatus, errorThrown ) {
                console.log("Error: Query Manager Web failure");
                console.log(data);
                console.log(textStatus);
                console.log(errorThrown);
                // hideLoadingIcon(iconid);
                if ($('#' + section_name + '-sidebar') ) {
                    $('#' + section_name + '-sidebar').hide();
                }
                if ( tryNumber <= 5 ) {
                    retry(displayRecordSummary(alias, type, id, version, section_name, tryNumber + 1), tryNumber + 1, 5);
                }
            });
        }
    }

}

/**
 * Display record graph region generated by Query Manager Web.
 * @param alias {string} record alias.
 * @param type {string} record type (index).
 * @param id {string} record id.
 * @param branchpages {string} [ Optional] Graph branch pages to show, separated by dashes,
 * e.g. 1-2-1 if the graph has 3 branches will show first page of the first branch, second page in the second branch and first page in the third branch.
 * If omitted, show the first page of every branch.
 * @param regionid {string} Parent element id in which the content will be rendered.
 * @param tryNumber {number} The number of times this function has been called.
 */
function displayRecordGraph( alias, type, id, branchpages, regionid, tryNumber ) {

    if ( alias && type && id && App && App.globalState && App.globalState.queryWebBase ) {

        var url = App.globalState.queryWebBase + '/recordgraph/' + alias + '/' + type + '/' + id + '/';

        if ( branchpages ) {
            url += '?branchpages=' + branchpages;
        }

        if ( url && regionid ) {

            var iconid = 'graph-loading-icon';

            // Display loading image
            var imageurl = "/static/images/skeleton-record-graph.png";
            loadSkeletonImage( regionid, iconid, imageurl );

            $.ajax({
                url: url,
                data: {},
                dataType: 'html'
            })
            .done(function ( data ) {

                // Display region data
                renderPageRegion( data, regionid );

                // Hide loading icon
                hideLoadingIcon( iconid );

                // Check if graph region has any children, and hide it if it doesn't
                var graph = $( '#graph-region' );
                if ( graph && graph.children() && graph.children().length <= 1 ) {
                    graph.css('height', '0px');
                    graph.hide();
                } else {
                    // Check if there is an empty graph
                    if ( graph ) {
                        var emptygraph = $('.empty-graph');
                        if ( emptygraph && emptygraph.length > 0 ) {
                            // Reduce the height of the tree region
                            graph.css('height', '100px');
                        } else {
                            // Increase the height of the tree region
                            graph.css('height', '750px');
                        }
                    }
                }

                // Listen for hierarchy graph leaf node click
                $('#graph-region .leaf-node').on('click', function(e) {
                    e.preventDefault();
                    var target = e.currentTarget;
                    navigateToLeafNode( target );
                });

                // Listen for hierarchy viewer pagination click
                $('#graph-region .tree-pagination-icon').on('click', function(e) {
                    console.log("Calling hierarchyPaginationListener")
                    hierarchyPaginationListener( e, regionid );
                });
            })
            .fail(function ( data, textStatus, errorThrown ) {
                console.log("Error: Query Manager Web failure");
                console.log(data);
                console.log(textStatus);
                console.log(errorThrown);
                hideLoadingIcon(iconid);
                if ( tryNumber <= 5 ) {
                    retry(displayRecordGraph(alias, type, id, branchpages, regionid, tryNumber + 1), tryNumber + 1, 5);
                }
            });
        }
    }

}

/**
 *Change the panels and Graph section
 */

/**
 * Display record risk matrix region generated by Query Manager Web.
 * @param alias {string} record alias.
 * @param type {string} record type (index).
 * @param id {string} record id.
 * @param tryNumber {number} The number of times this function has been called.
 */
function displayRecordRiskMatrix( alias, type, id, tryNumber ) {


    if ( alias && type && id && App && App.globalState && App.globalState.queryWebBase ) {

        var url = App.globalState.queryWebBase + '/recordriskmatrix/' + alias + '/' + type + '/' + id + '/';

        var regionid = 'risk_matrix-content';
        var iconid = 'riskmatrix-loading-icon';

        // Display loading image
        // var imageurl = "/static/images/skeleton-record-riskmatrix.png";
        // loadSkeletonImage( regionid, iconid, imageurl );

        $.ajax({
            url: url,
            data: {},
            dataType: 'html'
        })
        .done( function ( data ) {

            // Display region data
            renderPageRegion( data, regionid );

            // Hide loading icon
            // hideLoadingIcon( iconid );

        })
        .fail(function ( data, textStatus, errorThrown ) {
            console.log("Error: Query Manager Web failure");
            console.log(data);
            console.log(textStatus);
            console.log(errorThrown);
            // hideLoadingIcon(iconid);
            if ( tryNumber <= 5 ) {
                retry(displayRecordRiskMatrix(alias, type, id, tryNumber + 1), tryNumber + 1, 5);
            }
        });
    }
}

/**
 * Display record charts region generated by Query Manager Web.
 * @param alias {string} record alias.
 * @param type {string} record type (index).
 * @param id {string} record id.
 * @param tryNumber {number} The number of times this function has been called.
 */
function displayRecordCharts( alias, type, id, tryNumber ) {

    if ( alias && type && id && App && App.globalState && App.globalState.queryWebBase ) {

        var url = App.globalState.queryWebBase + '/recordcharts/' + alias + '/' + type + '/' + id + '/';

        var regionid = 'charts-content';
        var iconid = 'charts-loading-icon';

        // Display loading image
        var imageurl = "/static/images/skeleton-record-charts.png";
       // loadSkeletonImage( regionid, iconid, imageurl );

        $.ajax({
            url: url,
            data: {},
            dataType: 'html'
        })
        .done( function ( data ) {

            // Display region data
            renderPageRegion( data, regionid );

            // Hide loading icon
          //  hideLoadingIcon( iconid );

        })
        .fail(function ( data, textStatus, errorThrown ) {
            console.log( "Error: Query Manager Web failure" );
            console.log( data );
            console.log( textStatus );
            console.log( errorThrown );
           // hideLoadingIcon( iconid );
            if ( tryNumber <= 5 ) {
                retry(displayRecordCharts(alias, type, id, tryNumber + 1), tryNumber + 1, 5);
            }
        });
    }
}

/**
 * Display record panels region generated by Query Manager Web.
 * @param alias {string} record alias.
 * @param type {string} record type (index).
 * @param id {string} record id.
 * @param viewtype {string} record view type (i.e. "cdm", "ui", etc.).
 * @param version {*} [optional] EDI record iteration.
 * @param tryNumber {number} The number of times this function has been called.
 */
function displayRecordPanels( alias, type, id, viewtype, version, tryNumber ) {

    if ( alias && type && id && App && App.globalState && App.globalState.queryWebBase ) {

        var url = App.globalState.queryWebBase + '/recordpanels/' + alias + '/' + type + '/' + id + '/';

        if ( viewtype ) {
            url += '?viewtype=' + viewtype;
        }
        if ( viewtype && version ) {
            url += 'version=' + version;
        } else if ( version ) {
            url += '?version=' + version;
        }

        if ( url ) {

            var regionid = 'panels-content';
            var iconid = 'panels-loading-icon';

            // Display loading image
            var imageurl = "/static/images/skeleton-record-panels.png";
            loadSkeletonImage( regionid, iconid, imageurl );

            $.ajax({
                url: url,
                data: {},
                dataType: 'html'
            })
            .done( function ( data ) {

                // Display region data
                renderPageRegion( data, regionid );

                // Hide loading icon
                hideLoadingIcon( iconid );

            })
            .fail(function ( data, textStatus, errorThrown ) {
                console.log("Error: Query Manager Web failure");
                console.log(data);
                console.log(textStatus);
                console.log(errorThrown);
                hideLoadingIcon(iconid);
                if ( tryNumber <= 5 ) {
                    retry(displayRecordPanels(alias, type, id, viewtype, version, tryNumber + 1), tryNumber + 1, 5);
                }
            });
        }
    }
}

/**
 * Display record links region generated by Query Manager Web.
 * @param alias {string} record alias.
 * @param type {string} record type (index).
 * @param id {string} record id.
 * @param page {string|null} [optional] page number to show in the linked data table (defaults to 1).
 * @param tryNumber {number} The number of times this function has been called.
 */
function displayRecordLinks( alias, type, id, page, tryNumber ) {
    console.log(displayRecordLinks.name, "alias: ", alias, "type: ", type, "id: ", id, "page: ", page)

    if ( alias && type && id && App && App.globalState && App.globalState.queryWebBase ) {

        var url = App.globalState.queryWebBase + '/recordlinks/' + alias + '/' + type + '/' + id + '/';

        if ( page ) {
            url += '?page=' + page;
        }

        if ( url ) {
            var regionid = 'links-content';
            var iconid = 'links-loading-icon';

            // Display loading image
            var imageurl = "/static/images/skeleton-record-links.png";
          //  loadSkeletonImage( regionid, iconid, imageurl );

            $.ajax({
                url: url,
                data: {},
                dataType: 'html'
            })
            .done(function ( data ) {
                // console.log(displayRecordLinks.name, "url: ", url, "returndata:")
                // console.log(data)
                // Display region data
                renderPageRegion( data, regionid );

                // Hide loading icon
               // hideLoadingIcon( iconid );

                // Listen for table viewer pagination click
                $('#links-region .pagination-icon').on('click', function(e) {
                    // console.log("Calling linksPaginationListener")
                    linksPaginationListener( e );
                });

                // Listen for linked data table row click
                $('#links-region .clickable').on('click', function( e ) {
                    tableRowClickListener( e );
                });
            })
            .fail(function ( data, textStatus, errorThrown ) {
                console.log("Error: Query Manager Web failure");
                console.log(url)
                console.log(data);
                console.log(textStatus);
                console.log(errorThrown);
              //  hideLoadingIcon(iconid);
                if ( tryNumber <= 5 ) {
                    retry(displayRecordLinks(alias, type, id, page, tryNumber + 1), tryNumber + 1, 5);
                }
            });
        }
    }
}

/**
 * Display record tables region generated by Query Manager Web.
 * @param alias {string} record alias.
 * @param type {string} record type (index).
 * @param id {string} record id.
 * @param pages {null|string} Table pages, separated by dashes e.g. 1-1-1 starting with the first (top-most) table.
 * If omitted, the first page of every table is displayed.
 * @param tryNumber {number} The number of times this function has been called.
 */
// function displayRecordTables( alias, type, id, pages, tryNumber ) {                          
function displayRecordTables( alias, type, id, pages, tryNumber, target_id = '', tableSortString = '', scrollY_position = 0, print = false ) {

    if ( alias && type && id && App && App.globalState && App.globalState.queryWebBase ) {

        var url = App.globalState.queryWebBase + '/recordtables/' + alias + '/' + type + '/' + id + '/';


        if ( pages ) {
            url += '?linkedtablepages=' + pages; // Page size comes from the Query API query object in the response
        };

        if ( tableSortString !== '' ) {                                // ===== testing adding options to table calls for sorting
            url += '&linkedtablesorting=' + tableSortString;
        };

        var regionid = 'tables-content';
        var iconid = 'tables-loading-icon';

        // Display loading image
        var imageurl = "/static/images/skeleton-record-tables.png";
        loadSkeletonImage( regionid, iconid, imageurl );
        console.log(displayRecordTables.name, "In Here: URL", url)
        $.ajax({
            url: url,
            data: {},
            dataType: 'html'
        })
        .done(function ( data ) {

            // console.log('Record Tables Data: ', data );                                 // ===== testing only

            // Display region data
            renderPageRegion( data, regionid );

            // runs permissions check for title/row command buttons
            checkPerms();

            // Hide loading icon
            hideLoadingIcon( iconid );

            // Listen for table viewer pagination click
            $('#tables-region .pagination-icon').on('click', function(e) {
                console.log("Calling tablePaginationListener")
                tablePaginationListener( e );
            });

            // Listen for linked data table row click
            $('#tables-region .clickable').on('click', function( e ) {

                // checks if click was on a button, a link, or an input
                if ( e.target.tagName === 'BUTTON' || e.target.tagName === 'A' || e.target.tagName === 'INPUT' || e.target.closest(".rowcommandtd") ) {
                    return;
                }

                tableRowClickListener( e );
            });

            // sets scroll location to the paginated table
            if ( target_id != '' ) {
                console.log( 'target id: ', target_id );
                // document.getElementById( target_id ).scrollIntoView();

                // console.log('Set scrollY to: ', scrollY_position );

                // window.scrollTo(0, scrollY_position);           // ===== testing new scroll to option
            };

            if ( scrollY_position !== 0 ) {

                console.log('Set scrollY to: ', scrollY_position );

                window.scrollTo(0, scrollY_position);           // ===== testing new scroll to option
            };

            // checks for readonly parameter and hides buttons as appropriate on tables
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            // var readonly = urlParams.get('READONLY');
            var readonly = urlParams.get('R^$Pam');
            // if ( readonly == 'true' ) {
            if ( readonly == '$\\' ) {
                readonly_tables();
            };

            if ( print ) {
                console.log('window.print called');
                window.print();
            };

            // Moves record title buttons to below the tables
            move_recordHeader_btns();

        })
        .fail(function ( data, textStatus, errorThrown ) {
            console.log("Error: Query Manager Web failure");
            console.log(data);
            console.log(textStatus);
            console.log(errorThrown);
            hideLoadingIcon(iconid);
            if ( tryNumber <= 5 ) {
                retry(displayRecordTables(alias, type, id, pages, tryNumber + 1), tryNumber + 1, 5);
            }
        });
    }
}

/**
 * remove and re-render tables so that more results are displayed
 * This is so printing will show "all" paginated values
 * @param pagesize {int} (optional) sets the pagesize for all the tables
 * @param table_object {object} (optional) stores table size/page for individual tables of form { tablename: { tablepage: int, pagesize: int}}
 * @param print_window {bool} if true will run window.print after reloading the tables
 */
function printable_tables( pagesize = 500, table_object = {}, print_window = false ) {
    
    // App.globalState.pageSize = pagesize;
    
    var alias = App.globalState.alias;
    var type = App.globalState.documentType;
    var recordid = App.globalState.documentId;

    tablePagesString = ''

    var tablesRegionId = "tables-region";
    var currentpages = getCurrentTablePages( tablesRegionId );
    var tablenames = getTableNames( tablesRegionId );

    if ( currentpages && tablenames && currentpages.length === tablenames.length ) {
        for (var k = 0; k < currentpages.length; k++ ) {

            // var tablepage = Number( currentpages[ k ] );
            var tablepage = 1;
            var tablename = tablenames[ k ];

            if ( table_object.hasOwnProperty(tablename) ) {
                if ( table_object[tablename].hasOwnProperty('tablepage')) {
                    var tmp_tablepage = table_object[tablename].tablepage;
                } else {
                    var tmp_tablepage = tablepage;
                };
                if ( table_object[tablename].hasOwnProperty('pagesize')) {
                    var tmp_pagesize = table_object[tablename].pagesize;
                } else {
                    var tmp_pagesize = pagesize;
                };
            } else {
                var tmp_pagesize = pagesize;
                var tmp_tablepage = tablepage;
            };

            tablePagesString += tablename.replace(/-table$/, "") + ":" + tmp_tablepage + ":" + tmp_pagesize;
            if ( k < currentpages.length - 1 ) {
                tablePagesString += '|';
            };
        };
        App.globalState.tablePagesString = tablePagesString;
    };
    removePageContent('tables-content' );
    // displayRecordTables( alias, type, recordid, tablePagesString, 1 );
    displayRecordTables( alias, type, recordid, tablePagesString, 1, '', '', 0, print_window ); 
};

/**
 * remove and re-render tables with sorted columns
 * @param name {string} name of table to be sorted
 * @param sort {string} name of column in table to sort by
 * @param order {string} ascending 'a' or descending 'd' sorting order
 */
function sortable_tables( name, sort = '', order = '' ) {
    
    // var pagesize = App.globalState.pageSize;

    var tablePagesString = App.globalState.tablePagesString;

    var alias = App.globalState.alias;
    var type = App.globalState.documentType;
    var recordid = App.globalState.documentId;
    
    if ( App.globalState.tableSortString ) {
        var table_sort_string = App.globalState.tableSortString;
    } else {
        var table_sort_string = '';
    }

    var scrollY_position = window.scrollY;
    // var scrollX_position = window.scrollX;

    // tablePagesString = ''
    tableSortString = ''

    var tablesRegionId = "tables-region";
    var currentpages = getCurrentTablePages( tablesRegionId );
    var tablenames = getTableNames( tablesRegionId );

    console.log('tablename: ', tablenames );        // ===== testing only

    // if ( pagesize !== undefined && pagesize !== '' && pagesize !== 'undefined' ) {
    //     tablePagesString = ''
    //     if ( currentpages && tablenames && currentpages.length === tablenames.length ) {
    //         for ( var k = 0; k < currentpages.length; k++ ) {
    
    //             var tablepage = Number( currentpages[ k ] );
    //             // var tablepage = 1;
    //             var tablename = tablenames[ k ];
    
    //             tablePagesString += tablename.replace(/-table$/, "") + ":" + tablepage + ":" + pagesize;
    //             if ( k < currentpages.length - 1 ) {
    //                 tablePagesString += '|';
    //             }
    //         }
    //     }
    // };

    if ( sort !== '' && order !== '' ) {
        if ( tablenames && name && sort && order ) {
            if ( table_sort_string.includes( name.replace(/-table$/, "") ) ) {
    
                var tables = table_sort_string.split('|');
    
                for ( var k = 0; k < tables.length; k++ ) {
    
                    var table = tables[k]
                    var tableArr = table.split(':');
    
                    if ( tableArr[0] == name.replace(/-table$/, "") ) {
                        tableSortString += name.replace(/-table$/, "") + ":" + sort + ":" + order;
                    } else {
                        tableSortString += tableArr[0] + ':' + tableArr[1] + ':' + tableArr[2];
                    };
        
                    if ( k < tables.length - 1 ) {
                        tableSortString += '|';
                    }
                }
            } else {
                if ( table_sort_string !== '' ) {
                    tableSortString += table_sort_string + '|';
                };
                tableSortString += name.replace(/-table$/, "") + ':' + sort + ':' + order;
            };
    
            // App.globalState.tableSortString = tableSortString
        };
    } else {
        tableSortString += table_sort_string;
    };

    App.globalState.tableSortString = tableSortString;


    removePageContent('tables-content' );
    displayRecordTables( alias, type, recordid, tablePagesString, 1, '', tableSortString, scrollY_position );
};

/**
 * Hides table command buttons for "readonly" tables
 */
function readonly_tables() {
    var elem_arr = [];

    elem_arr.push.apply( elem_arr, document.getElementsByClassName('titlecommandbtn'));
    elem_arr.push.apply( elem_arr, document.getElementsByClassName('rowcommandtd'));
    elem_arr.push.apply( elem_arr, document.getElementsByClassName('rowcommandth'));
    elem_arr.push.apply( elem_arr, document.getElementsByClassName('rowcommandbtn'));
    elem_arr.push.apply( elem_arr, document.getElementsByClassName('rowcommandobj'));

    elem_arr.slice().reverse().forEach(elem => elem.remove());
};

/**
 * something
 * @param id {string} checkbox class
 */
function sendEmail(id){
    var chkbox_class = id 
    var prefill
    console.log(chkbox_class)
    $("." + chkbox_class + "_checkbox:checked").each(function(index,val){
              console.log($(this))
      console.log($(this).attr("parameters_field"))
      if(!prefill)
            prefill=$(this).attr("parameters_field")
      else
          prefill+="$$$$" + $(this).attr("parameters_field")
    })
    console.log(prefill)
    location.href="/explore/api/v1/sendCCEmail/lsahconsent_ls_study?subjectList=" + prefill
};


/**
 * Hide/show the element body. Switch plus and minus icon styles (show one and hide the other).
 * @param el {object} DOM object that contains plus and minus icons.
 * @param children {Array} Array of DOM elements.
 * @param istable {boolean} Flag to indicate that the element being manipulated is a table.
 * @param pagination {*} If the element is a table, pagination DOM element, or null otherwise.
 */
function hideElementSwitchIcons( el, children, istable, pagination ) {

    var minus; // minus icon
    var plus; // plus icon

    if ( el && el.style ) {
        if ( children && children.length > 1 ) {

            minus = children[0];
            plus = children[1];

            if ( minus && plus ) {

                // Switch minus and plus

                var minusClassList = minus.classList;
                var plusClassList = plus.classList;

                var minusClass;
                var plusClass;

                if ( minusClassList && minusClassList.length > 0 ) {
                    minusClass = minusClassList[0];
                }

                if ( plusClassList && plusClassList.length > 0 ) {
                    plusClass = plusClassList[0];
                }
            }
        }

        if ( el.style.display !== "none" ) {

            // Hide element body

            el.style.display = "none";

            // Show pagination

            if ( istable && pagination && pagination.style ) {
                pagination.style.display = "none";
            }

            // Hide minus icon
            // Show plus icon

            if ( minus && plus && minus.style && plus.style && minusClass === "minus-icon" && plusClass === "plus-icon" ) {
                minus.style.display = "none";
                plus.style.display = "block";
            }
        }
        else {

            // Show element body
            if ( istable ) {
                el.style.display = "table";

                // Show pagination

                if ( pagination && pagination.style ) {
                    pagination.style.display = "block";
                }


            } else {
                el.style.display = "block";
            }

            // Show minus icon
            // Hide plus icon

            if ( minus && plus && minus.style && plus.style && minusClass === "minus-icon" && plusClass === "plus-icon" ) {
                minus.style.display = "block";
                plus.style.display = "none";
            }
        }
    }
}

/**
 * Show / hide table body on click like an accordion.
 * Switch minus/plus icon depending on the panel state (collapsed/expanded).
 * @param el {object} Table title DOM element.
 */
function tableTitleClickListener( el ) {

    /* Toggle between hiding and showing table body */
    if ( el ) {

        var parent = el.parentElement;


        if ( parent ) {
            var pagination = parent.nextElementSibling;
            if ( pagination ) {
                var table = pagination.nextElementSibling;

                if ( table && table.style ) {

                    var children = el.children;

                    hideElementSwitchIcons( table, children, true, pagination );
                }
            }


        }

    }
}

/**
 * Redirect to the single record view for the record which row was clicked on the table.
 * @param e {object} Click event on the table row element.
 */
function tableRowClickListener( e ) {

    e.preventDefault();

    var target = $( e.currentTarget );


    if ( target ) {
        var id = target.attr("id");
        var type = target.attr("type");

        // Redirect to the new single record page

        if ( id && type ) {
            var newURL = type + "/" + id;
            if ( App && App.globalState ) {
                var oldtype = App.globalState.documentType;
                var oldid = App.globalState.documentId;
                if ( oldtype && oldid ) {
                    var oldURL = oldtype + "/" + oldid;
                    if ( target.attr("nav_url") ) {                 // overrides url with nav_url if present
                        var newURL = target.attr("nav_url");
                        var oldURL = "view/" + App.globalState.alias + "/" + oldtype + "/" + oldid;

                        window.location.href = newURL;
                    } else {
                        updateEndURL( newURL, oldURL, true );
                    };
                }
            }
        }
    }
}

/**
 * Show the next/previous page of the linked data table defined in the model table_viewers field.
 * @param e {object} Pagination arrow element.
 */
function tablePaginationListener( e ) {

    e.preventDefault();

    var target = $( e.currentTarget );

    // console.log('target parent parent  element: ', target[0].parentElement.closest('div') );     // =====
    const target_id = target[ 0 ].parentElement.closest('div').id;

    // Construct table pages string expected by the Query Manager Web service
    // paginationResult object contains two fields: tablePagesString (string) and pagechange (boolean)
    var paginationResult = getTablePagination( target, "tables-region" );
    console.log("Table Pagination Result")
    console.log(paginationResult)
    // Call Query Manager Web with updated table pages
    if ( App && App.globalState ) {

        var alias = App.globalState.alias;
        var type = App.globalState.documentType;
        var recordid = App.globalState.documentId;
        var table_sort_string = App.globalState.tableSortString;
        console.log("Calling to tables endpoint", alias, type, recordid)
        // Call tables endpoint depending on where the call came from
        if ( paginationResult.tablePagesString && paginationResult.pagechange && alias && type && recordid ) {

            // Remove current tables content
            removePageContent('tables-content' );

            // Get updated tables
            displayRecordTables( alias, type, recordid, paginationResult.tablePagesString, 1, target_element = target_id, table_sort_string );

        }
    }
}

/**
 * Show the next/previous page of the linked data table.
 * @param e {object} Pagination arrow element.
 */
function linksPaginationListener( e ) {

    e.preventDefault();

    var target = $( e.currentTarget );

    // Construct table pages string expected by the Query Manager Web service
    // paginationResult object contains two fields: tablePagesString (string) and pagechange (boolean)
    var paginationResult = getTablePagination( target, "links-region" );

    console.log(linksPaginationListener.name, "before calling query manager web", App.globalState)
    // Call Query Manager Web with updated table pages
    if ( App && App.globalState ) {
        //     var apiBase = App.globalState.queryWebBase;
        var alias = App.globalState.alias;
        var type = App.globalState.documentType;
        var id = App.globalState.documentId;

        console.log(linksPaginationListener.name, "inside call", paginationResult)
        // Call tables or links endpoint depending on where the call came from
        if ( paginationResult.tablePagesString && paginationResult.pagechange && alias && type && id ) {

            // Remove current links table
            removePageContent( 'links-content' );

            // Get updated links table
            displayRecordLinks( alias, type, id, paginationResult.tablePagesString );
        }
    }
}

/**
 * Get table pagination pages string, separated by dashes for each table, and a boolean flag is a page change occurred and is valid.
 * @param target {object} Pagination element arrow.
 * @param tablesRegionId {string} Tables region element ID inside which tables are displayed.
 * @returns {object} Return object has two fields: tablePagesString {string} and pagechange {boolean}
 */
function getTablePagination( target, tablesRegionId ) {

    var result = {};

    result.tablePagesString = '';
    result.pagechange = false;
    result.pagesize = '';

    var nPages;

    if ( target && target.length > 0 && target[0] ) {

        var parent = target[0].parentElement;

        if ( parent && $( parent )) {
            var previous = $( parent ).hasClass( "previous-page" );
            var next = $( parent ).hasClass( "next-page" );
            var pages = $( parent ).siblings('.table-pages');


            // Determine what page to show
            if ( pages ) {

                var text = pages.text();

                // Get total number of pages from the text of the table that was paginated
                if ( text ) {

                    var pagesArray = text.split("out of ");

                    if ( pagesArray && pagesArray.length === 2 ) {

                        var nPagesString = pagesArray[ 1 ];
                        nPages = Number( nPagesString );
                    }
                }

                // Get the table pagination element
                var pagination = $( parent ).parent();

                if ( pagination && $( pagination ) ) {
                    var table = $( pagination ).parent();

                    if ( table && $( table )) {

                        // Get table id that was clicked on
                        var id = $( table ).attr("id");

                        // Get all tables

                        var currentpages = getCurrentTablePages( tablesRegionId );


                        var tablenames = getTableNames( tablesRegionId );
                        console.log(getTablePagination.name, currentpages)
                        console.log(getTablePagination.name, tablenames)

                        if ( currentpages && tablenames && currentpages.length === tablenames.length ) {
                            for (var k = 0; k < currentpages.length; k++ ) {

                                var tablepage = Number( currentpages[ k ] );
                                var tablename = tablenames[ k ];

                                // Update the clicked on table page
                                if ( tablepage && id && nPages && id === tablename ) {

                                    // Previous page click
                                    if ( previous && ! next && tablepage > 1 ) {
                                        tablepage--;
                                        result.pagechange = true;
                                    }
                                    // Next page click
                                    else if ( next && ! previous && tablepage < nPages ) {
                                        tablepage++;
                                        result.pagechange = true;
                                    }
                                }

                                result.tablePagesString += tablename.replace(/-table$/, "") + ":" + tablepage;
                                if ( k < currentpages.length - 1 ) {
                                    result.tablePagesString += '|';
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    //console.log(getTablePagination.name, ": result", result)
    return result;
}

/**
 * Get all table pages in the linked records section.
 * Returns an array of numbers, in the order of appearance on the page from top to bottom.
 * @param parentId {string} DOM element ID inside which the tables are displayed. If omitted, empty array is returned.
 * @returns {Array}
 */
function getCurrentTablePages( parentId ) {

    var result = [];

    // Get all current table pages

    var tablenames = getTableNames( parentId );

    if ( tablenames ) {

        for ( var i = 0; i < tablenames.length; i++ ) {

            var tablename = tablenames[ i ];

            if ( tablename && $( '#' + tablename ) ) {

                var pages = $( '#' + tablename ).find( '.table-pages' );


                // Get total number of pages from the text

                if ( pages && $( pages )) {

                    var text = $( pages ).text();


                    if ( text ) {

                        var pagesArray = text.split("out of ");

                        if ( pagesArray && pagesArray.length === 2 ) {

                            var pagesString = pagesArray[ 0 ];

                            if ( pagesString ) {
                                var pageArray = pagesString.split("Page ");


                                if (pageArray && pageArray.length === 2) {
                                    var pageString = pageArray[1];
                                    var page = Number( pageString );

                                    if ( page ) {
                                        result.push( page );
                                    }
                                }
                            }
                        }
                    }
                    else {
                        result.push( 0 );
                    }
                } else {
                    result.push( 0 );
                }
            } else {
                result.push( 0 );
            }
        }
    }

    return result;
}

/**
 * Get all table names (their unique id attribute) in the linked records section.
 * Returns an array of strings, in the order of appearance on the page from top to bottom.
 * @param parentId {string} DOM element ID inside which the tables are displayed. If omitted, empty array is returned.
 * @returns {Array}
 */
function getTableNames( parentId ) {

    var result = [];

    if ( parentId ) {
        var parent = document.getElementById( parentId );
        if ( parent ) {

            var tabletitlebuttons = parent.querySelectorAll( ".table-title-button" );

            if ( tabletitlebuttons ) {
                for ( var p = 0; p < tabletitlebuttons.length; p++ ) {

                    var title = tabletitlebuttons[p];

                    if (title) {
                        var parentdiv = $(title).parent();

                        if (parentdiv) {
                            var tablediv = $(parentdiv).parent();

                            if ( tablediv ) {
                                var id = $(tablediv).attr("id");
                                if ( id ) {
                                    result.push( id );
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    return result;

}

/**
 * Show Common Data Model (CDM) fields in the record metadata section.
 * @param e {object} CDM button click event.
 */
function cdmButtonClickListener( e ) {

    e.preventDefault();

    // Call Query Manager Web with CDM view
    if ( GlobalPageState ) {
        getRecordUI( GlobalPageState.alias, GlobalPageState.type, GlobalPageState.id, "cdm", null );
    }
}

/**
 * Show source (EDI) fields in the record metadata section.
 * @param e {object} EDI button click event.
 */
function ediButtonClickListener( e ) {

    e.preventDefault();

    // Call Query Manager Web with CDM view
    if ( GlobalPageState ) {
        getRecordUI( GlobalPageState.alias, GlobalPageState.type, GlobalPageState.id, "ui", null );
    }
}

/**
 * Redirect to the viewer page in EDI.
 * @param e {object} EDI viewer link click event.
 */
function viewerLinkListener( e ) {

    e.preventDefault();

    var target = $( e.currentTarget );

    if ( target ) {

        // Get link attributes that contain viewer type and id
        var viewertype = target.attr( "viewertype" );
        var viewerid = target.attr( "viewerid" );


        if ( viewertype && viewerid ) {
            clickViewerLink( viewerid, viewertype );
        }

    }
}

/**
 * Get JSON model for the type and fetch data for the record
 * @param type {string} - data type
 * @param id {string} - unique EDI id
 * @param section {*} - page section name or null for the whole page
 */
function getRecord( type, id, section ) {

    var pageName = "record", // In the future, page name comes from the router
        layoutView;

    if ( type && id ) {

        GlobalPageState = initialGlobalPageState( pageName, type );
        if ( ! GlobalPageState ) {
            GlobalPageState = {};
        }

        // Store page name, type and id into the global state
        GlobalPageState.currentPage = pageName;
        GlobalPageState.type = type;
        GlobalPageState.id = id;
        GlobalPageState.data = {};  // Initialize empty global data object
        GlobalPageState.models = {}; // Initialize empty global data models object
        GlobalPageState.search = {}; // Initialize empty global search ui models object
        GlobalPageState.linksPageNumber = 1; // Initialize linked data page number to 1
        GlobalPageState.collapse = App.globalState.collapse; // Initialize collapse variable that's used on views with a PBS graph
        GlobalPageState.view = "edi";

        layoutView = getLayoutView( pageName, type, section );
        if ( layoutView ) {
            GlobalPageState.layout = layoutView;
            constructView( );
        }
    }
}

/**
 * Call Search API to get single record data
 * @param regionsCollection {Backbone.Collection} - collection of data URL models
 * @param viewModel {Backbone.Model} - region view model
 * @param recordModel {BackboneModel} - Backbone.Model of the page
 */
function getSingleRecordData( regionsCollection, viewModel, recordModel ) {

    var pageName,
        page,
        response,
        dataNames,
        urls,
        i;

    if ( recordModel ) {
        pageName = recordModel.get( "pageName" );
        page = recordModel.get( "page" );

        if ( pageName && page ) {
            _.each( regionsCollection.models, function ( model ) {

                response = {};
                dataNames = model.get("data") || [];
                urls = model.get("urls") || [];

                if ( urls && dataNames ) {
                    if ( urls.length === dataNames.length ) {
                        // URLs have no dependencies
                        for ( i = 0; i < dataNames.length; i++ ) {
                            makeAjaxRequest( urls[i], storeResponse( dataNames[i], dataNames, urls, response, pageName, viewModel, page ), dataNotFound( urls[ i ] ) );
                        }
                    } else {
                        // Some URLs depend on a data point from another URL
                        // For those URLs length of the urls array will be smaller than length of the dataNames array
                        // Make a call to the parent url, then get dependent child url
                        for ( i = 0; i < urls.length; ++i ) {
                            makeAjaxRequest( urls[i], storeResponse( dataNames[i], dataNames, urls, response, pageName, viewModel, page ), dataNotFound( urls[ i ] ) );
                        }
                    }
                }
            });
        }
    }
}

/**
 * Navigate to the selected record version.
 * @param target {object} Version select element
 */
function selectRecordVersion( target ) {

    if ( target && $( target ) ) {

        var option = $( target ).find("option:selected");

        if ( option ) {

            var version = option.attr("value");

            var pagestate = getGlobalPageState();

            if ( pagestate ) {
                var alias = pagestate.alias;
                var type = pagestate.type;
                var id = pagestate.id;
                var viewtype = pagestate.viewtype;

                var content =  $('#content');
                if ( content ) {
                    content.empty();
                }

                getRecordUI( alias, type, id, viewtype, version );
            }

        }
    }
}
